import axios from "axios";
import https from "https";

export interface BridgeCredentials {
  username: string;
  clientkey: string;
}

/**
 * Register with the Hue Bridge and retrieve both the CLIP API username
 * and the Entertainment clientkey in one request.
 *
 * @param appName – your app identifier, e.g. "my-hue-app"
 * @param bridgeIp – the Hue Bridge’s LAN IP
 * @returns an object containing { username, clientkey }
 */
export async function connectBridge(
  appName: string,
  bridgeIp: string
): Promise<BridgeCredentials> {
  console.log(`Press the button on your Hue Bridge to proceed...`);

  const maxRetries = 30;
  let retries = 0;

  while (retries < maxRetries) {
    try {
      const response = await axios.post(
        `https://${bridgeIp}/api`,
        {
          devicetype: appName || "my-hue-app",
          generateclientkey: true
        },
        {
          httpsAgent: new https.Agent({ rejectUnauthorized: false })
        }
      );

      console.log("🔍 Full response from Hue Bridge:", response.data);
      const entry = response.data[0];

      if (entry?.success) {
        const { username, clientkey } = entry.success;
        console.log(`✅ Registered username: ${username}`);
        console.log(`✅ Received clientkey: ${clientkey}`);
        return { username, clientkey };
      }

      if (entry?.error?.type === 101) {
        console.log(` Waiting for button press... (${retries + 1}/${maxRetries})`);
        retries++;
        await new Promise((res) => setTimeout(res, 2000));
        continue;
      }

      throw new Error(`Unexpected response: ${JSON.stringify(entry)}`);
    } catch (err: any) {
      console.error("Request failed:", err.message);
      throw err;
    }
  }

  throw new Error("❌ Failed to register after 30 attempts.");
}